module.exports = __webpack_public_path__ + "static/img/logo11.b042d3e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo11.png
// module id = Ohr1
// module chunks = 1